import React, { useEffect } from 'react'
import styled, { css } from 'styled-components'

import NextSeo from '../components/NextSeo'
import { useTranslation } from '../i18n'
import { getColor, getFontSize } from '../utils/cssUtils'
import { aboutUsView } from '../utils/dataTracker'
import mq from '../utils/mediaQuery'

const Wrapper = styled.div`
  width: 100%;
  padding: 56px 0 40px 0;
  background-color: #ffffff;
  ${mq.mobile} {
    padding: 24px 0px 24px 0px;
  }
`
const Container = styled.div`
  max-width: 792px;
  margin: 0 auto;
  @media (max-width: 767px) {
    margin: 0 16px;
  }
`
const Header = styled.p`
  height: 24px;
  font-size: ${getFontSize('headline')};
  font-weight: 600;
  line-height: 1;
  letter-spacing: normal;
  color: ${getColor('grey')};
`
const Paragraph = styled.p`
  line-height: 1.87;
  letter-spacing: 1px;
  font-size: ${getFontSize('body2')};
  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `}
`

const About = () => {
  const { t } = useTranslation('common')

  useEffect(() => {
    aboutUsView()
  }, [])

  return (
    <Wrapper>
      <NextSeo
        title={t('seo.aboutusPage.ogTitle')}
        description={t('seo.aboutusPage.ogDescription')}
      />
      <Container>
        <Header>「01心意」</Header>
        <Paragraph bold>用心意成就好事</Paragraph>
        <Paragraph>
          「01心意」於2019年1月7日成立，是全港首個結集線上推廣、線下互動的慈善籌款平台。善用互聯網資訊傳播，我們與多間慈善團體合作舉辦不同類型的籌款活動，配合專訪報道及推行不同市場推廣計劃，至今已為平台上超過130間慈善團體籌得逾2,600萬港元善款。展望未來，我們希望把這份心意繼續傳播開去，幫助更多弱勢社群。
        </Paragraph>
        <br />
        <Paragraph bold>我們相信：點滴心意，成就改變！</Paragraph>
        <Paragraph>
          施比受更有福，我們相信一份小小的心意，足以為社會上不幸的人帶來希望與祝福，改變他們的生活。由今日起，除了在社交平台上「畀心心」，也可直接坐言起行，於「01心意」上捐款支持心儀的慈善團體，幫助社會上有需要的人！
        </Paragraph>
        <br />
        <Paragraph bold>
          我們的使命：你 + 慈善團體 + 服務對象 = 「01心意」
        </Paragraph>
        <Paragraph>
          《香港01》將平台命名為「01心意」，希望將受忽略群體的心聲、慈善團體的熱誠及大眾的行動力與同理心連結起來，為社會帶來改變——用心意成就好事。
        </Paragraph>
        <br />
        <Paragraph bold>零行政費、上架費 善款100%支持受惠對象</Paragraph>
        <Paragraph>
          《香港01》及「01心意」絕不向慈善團體、受惠對象或捐款者收取任何行政費或上架費，善款全數會直接捐予受惠機構。
        </Paragraph>
        <br />
      </Container>
    </Wrapper>
  )
}

export default About
